const toNumberOrDefault = (value, fallback = 0) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : fallback;
};

const normalizeText = (value, fallback = "") => {
    if (value === null || value === undefined) {
        return fallback;
    }
    const text = String(value).trim();
    return text || fallback;
};

const createStandardTrackingEvents = (sendManualEvent) => {
    const trackSearchSubmit = (payload = {}) =>
        sendManualEvent({
            name: "search_submit",
            category: "search",
            customValue: {
                serviceId: toNumberOrDefault(payload.serviceId, 0),
                serviceName: normalizeText(
                    payload.serviceName,
                    "Search Service",
                ),
                serviceType: normalizeText(payload.serviceType, "search_form"),
                keyword: normalizeText(payload.keyword, ""),
                operation: normalizeText(payload.operation, "submit"),
                locLat: payload.locLat,
                locLon: payload.locLon,
                account: payload.account,
                serviceIp: payload.serviceIp,
                device: payload.device,
                datetime: payload.datetime,
            },
        });

    const trackProductView = (payload = {}) =>
        sendManualEvent({
            name: "product_view",
            category: "product",
            customValue: {
                serviceId: toNumberOrDefault(payload.serviceId, 0),
                serviceName: normalizeText(
                    payload.serviceName,
                    "Product Detail",
                ),
                serviceType: normalizeText(payload.serviceType, "product"),
                keyword: normalizeText(payload.keyword, ""),
                operation: normalizeText(payload.operation, "view"),
                locLat: payload.locLat,
                locLon: payload.locLon,
                account: payload.account,
                serviceIp: payload.serviceIp,
                device: payload.device,
                datetime: payload.datetime,
            },
        });

    const trackContactSubmit = (payload = {}) =>
        sendManualEvent({
            name: "contact_submit",
            category: "contact",
            customValue: {
                serviceId: toNumberOrDefault(payload.serviceId, 0),
                serviceName: normalizeText(payload.serviceName, "Contact Form"),
                serviceType: normalizeText(payload.serviceType, "contact_form"),
                keyword: normalizeText(payload.keyword, ""),
                operation: normalizeText(payload.operation, "submit"),
                locLat: payload.locLat,
                locLon: payload.locLon,
                account: payload.account,
                serviceIp: payload.serviceIp,
                device: payload.device,
                datetime: payload.datetime,
            },
        });

    return {
        trackSearchSubmit,
        trackProductView,
        trackContactSubmit,
    };
};

export default createStandardTrackingEvents;
